import React from "react";
import RecomendationComponentLazyLoad from "./RecomendationComponentLazyLoad";

const FrequentlyBoughtTogether: React.FC = () => {
  return <RecomendationComponentLazyLoad recommendationsPageName="product-page-v2-5" />;
};

export default FrequentlyBoughtTogether;
